import Vue from "vue";
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: "G-87RSS11V7V" },
});
